import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { RequestParams, ResponseCatalog } from 'Models'
import { TemplateModel } from 'Pages/admin/notification'

export const templateApi = {
	getList: async (requestParams: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<TemplateModel>>(
			`${urls.notification.template}`,
			{
				params: requestParams,
			}
		)
		return res.data
	},
	updateOne: async (id: number, data: TemplateModel) => {
		const res = await axiosDS().patch<TemplateModel>(`${urls.notification.template}/${id}`, {
			data,
		})
		return res.data
	},
	getOne: async (id: number) => {
		const res = await axiosDS().get<TemplateModel>(`${urls.notification.template}/${id}`)
		return res.data
	},
}
